import { render } from "./TablePublish.vue?vue&type=template&id=a570b14e&scoped=true"
import script from "./TablePublish.vue?vue&type=script&lang=js"
export * from "./TablePublish.vue?vue&type=script&lang=js"

import "./TablePublish.vue?vue&type=style&index=0&id=a570b14e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a570b14e"]])

export default __exports__